import React, { useMemo } from 'react';

import { NullableFormatter } from '~/@components/Formatters';
import { ActionVariant, ITableCellAction, TableCellActions } from '~/@components/Table/TableCellActions';
import { IDeliveryLine } from '~/@store/deliveryLines';

type Props = {
    deliveryLine: IDeliveryLine;
};

export const DeliveryLineCustomerInvoiceCell = ({ deliveryLine }: Props) => {
    const actions: Array<ITableCellAction> = useMemo(
        () => [
            {
                variant: ActionVariant.COPY,
                content: deliveryLine.customerInvoiceNumber,
            },
        ],
        [deliveryLine]
    );

    return (
        <TableCellActions actions={actions}>
            <NullableFormatter>{deliveryLine.customerInvoiceNumber}</NullableFormatter>
        </TableCellActions>
    );
};
